/**
 * Environment configuration with strict validation.
 * Throws an error if any required environment variable is missing.
 *
 * IMPORTANT: use static `import.meta.env.VITE_*` access here (never dynamic
 * `import.meta.env[key]`). Vite replaces static references at build time so
 * the correct value is always baked into the bundle regardless of build mode.
 * Dynamic access falls back to the runtime env object which Vite only
 * populates from vars explicitly referenced statically elsewhere in the code.
 */

interface IEnvConfig {
  api: {
    baseUrl: string;
  };
}

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
if (!apiBaseUrl) {
  throw new Error('Missing required environment variable: VITE_API_BASE_URL. Please check your .env file.');
}

/**
 * Validated environment configuration.
 */
export const config: IEnvConfig = {
  api: {
    baseUrl: apiBaseUrl,
  },
};
